module.exports = __webpack_public_path__ + "media/img/event/cardiff-homepage-banner-dc577fab3bc9188ef6ca24030225e009.png";